export const APPROVED_SMART_COOLER_PRODUCTS_TEST_IDS = {
  PAGE: 'approved-smart-cooler-products-page',
  SEARCH_PRODUCT_ID: 'approved-smart-cooler-products-search-product-id',
  SEARCH_BARCODE: 'approved-smart-cooler-products-search-barcode',
  SEARCH_NAME: 'approved-smart-cooler-products-search-name',
  EXPORT_BTN: 'approved-smart-cooler-products-export-btn',
  ADD_BTN: 'approved-smart-cooler-products-add-btn',
  SUBAPP_SELECT: 'approved-smart-cooler-products-subapp-select',
  DELETED_TOGGLE: 'approved-smart-cooler-products-deleted-toggle',
  TABLE: 'approved-smart-cooler-products-table',
  TABLE_ROW: (id: string) => `approved-smart-cooler-products-table-row-${id}`,
  COL_SCP_ID: (id: string) => `approved-smart-cooler-products-col-scp-id-${id}`,
  COL_LEGACY_ID: (id: string) => `approved-smart-cooler-products-col-legacy-id-${id}`,
  COL_SUBAPP: (id: string) => `approved-smart-cooler-products-col-subapp-${id}`,
  COL_NAME: (id: string) => `approved-smart-cooler-products-col-name-${id}`,
  COL_STATUS: (id: string) => `approved-smart-cooler-products-col-status-${id}`,
  COL_LAST_CHANGED: (id: string) =>
    `approved-smart-cooler-products-col-last-changed-${id}`,
  COL_CREATED_ON: (id: string) => `approved-smart-cooler-products-col-created-on-${id}`,
  COL_UPDATED_ON: (id: string) => `approved-smart-cooler-products-col-updated-on-${id}`,
  COL_EDIT_BTN: (id: string) => `approved-smart-cooler-products-col-edit-btn-${id}`,
  COL_DELETE_BTN: (id: string) => `approved-smart-cooler-products-col-delete-btn-${id}`,
  COL_ACTIVATE_BTN: (id: string) =>
    `approved-smart-cooler-products-col-activate-btn-${id}`,

  // ── Expanded row panel ───────────────────────────────────────────────
  EXPANDED_PANEL: 'approved-smart-cooler-products-expanded-panel',
  EXPANDED_TAB_CONTROL: 'approved-smart-cooler-products-expanded-tab-control',
  EXPANDED_IMAGE: 'approved-smart-cooler-products-expanded-image',
  EXPANDED_BARCODES: (idx:string) => `approved-smart-cooler-products-expanded-barcodes-${idx}`,
  EXPANDED_PRODUCT_INFO: 'approved-smart-cooler-products-expanded-product-info',
  EXPANDED_HISTORY: 'approved-smart-cooler-products-expanded-history',
} as const;
